import React from 'react';

const Ruler = ({ top, sizeClass, rows }) => (
    <div className={`hoz_measure clearfix ${sizeClass}`} style={{top, display: 'block'}}>
        {[...Array(rows)].map((item, index) => {
            return (
                <div key={`measure-${index}`} className="ruler-row clearfix">
                    <div className="tall"></div>
                    <div className="mid"></div>
                </div>
            )
        })}
    
    </div>
)

export default Ruler



// WEBPACK FOOTER //
// ./src/partials/Ruler.js